import { notifyOnError } from '~/rage/decorators';
import { SeenTracker, Subject } from '~/rage/utils';
import { ProductShopItemConfig, ProductShopType, WalletType } from '~/shared';
import { BackendService } from '../BackendService';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { IProductShopService } from './productShopServiceTypes';

export class ProductShopService implements IProductShopService {
	private readonly items = new Subject<ProductShopItemConfig[]>([]);
	private readonly productShopType = new Subject<ProductShopType>(
		ProductShopType.EVERYDAY,
	);
	private seenTracker = new SeenTracker('product_shop');

	constructor(
		private readonly gameConfig: GameConfigService,
		private readonly rpc: RpcService,
		private readonly backend: BackendService,
		private readonly vars: VarsService,
	) {
		this.vars
			.get('productShop:shopType', ProductShopType.EVERYDAY)
			.subscribe((value) => {
				this.productShopType.next(value);
				this.filterItems();
			});

		this.gameConfig.getConfigs().subscribe(() => {
			this.filterItems();
		});
	}

	private filterItems(): void {
		if (!this.gameConfig.configs) return;
		const items = this.gameConfig.configs.productShop?.items ?? [];
		const currentType = this.productShopType.getValue();
		this.items.next(items.filter((item) => item.type === currentType));
	}

	public getItems(): Subject<ProductShopItemConfig[]> {
		return this.items;
	}

	public getProductShopType(): Subject<ProductShopType> {
		return this.productShopType;
	}

	@notifyOnError
	public async buy(
		itemId: string,
		count: number,
		walletType: WalletType,
	): Promise<void> {
		await this.backend.invoke('productShop:buy', { itemId, count, walletType });
	}

	public isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	public markSeen(path: string): void {
		this.seenTracker.markAsSeen(path);
	}

	@notifyOnError
	public async exitMenu(): Promise<void> {
		await this.rpc.invokeClient('productShop:exitMenu');
	}
}
